import { ReactComponent as CalendarIcon } from './calendar.svg';

export default CalendarIcon;
